import React from "react";
import styled from "styled-components";

interface KpiCardProps {
  label: string;
  value: number | string;
  sub: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  accentColor: string;
}

const KpiCard = ({ label, value, sub, icon, iconBg, iconColor, accentColor }: KpiCardProps) => {
  return (
    <Card>
      <Top>
        <IconWrap style={{ background: iconBg }}>
          <i className={`ti ${icon}`} style={{ fontSize: 17, color: iconColor }} aria-hidden="true" />
        </IconWrap>
        <Label>{label}</Label>
      </Top>
      <Value>{value}</Value>
      <Sub>{sub}</Sub>
      <Stripe style={{ background: accentColor }} />
    </Card>
  );
};

export default KpiCard;

const Card = styled.div`
  background: #ffffff;
  border: 0.5px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  position: relative;
  overflow: hidden;
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

const IconWrap = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Label = styled.span`
  font-size: 11px;
  color: #888780;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const Value = styled.span`
  font-size: 30px;
  font-weight: 500;
  color: #2c2c2a;
  line-height: 1.1;
  padding-left: 0;
`;

const Sub = styled.span`
  font-size: 11px;
  color: #b4b2a9;
`;

const Stripe = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  border-radius: 0;
`;
